import { store } from '../../store'
import { httpgst } from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({ commit, dispatch }, payload) {
    let url = `api/reports/expenses-by-category-and-branch/${payload.event.item.url}`
    let options = { headers: {'Content-Type': 'application/json'} }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  downloadReport ({ commit, dispatch }, payload) {
    let url = `api/reports/expenses-by-category-and-branch/${payload.event.item.url}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options)
      .then(
        response => {
          commit('onDownloadReport', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let report = payload.response.data.data

    payload.event.context.itemsTable = report
    payload.event.context.show = true
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  },
  onDownloadReport (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.startDate} - ${payload.event.context.finishDate}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  onError (state, payload) {
    if(payload.error.response && payload.error.response.status === 429 && payload.error.response.data && !payload.error.response.data.message) {
      payload.error.response.data.message = payload.event.context.showNotification(payload.event.context.$t('general.erroTimeout'), 'error', -1)
    }else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportExpensesCategoryBranch.js